import {
  GET_TEAM,
  RECEIVED_TEAM,
  GET_TEAM_SUCCESS,
  GET_TEAM_FAILED,
  INVITE_TEAM,
  INVITE_TEAM_SUCCESS,
  INVITE_TEAM_FAILED,
  RESET_INVITE_STATUS,
  DELETE_TEAM,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILED,
  RESET_DELETE_STATUS,
  RESET_TEAM_ERROR,
} from "./actionType";

const INIT_STATE = {
  team: [],
  error: "",
  inviteError: "",
  deleteError: "",
  status: "idle", // or: 'loading', 'success', 'failed'
  inviteStatus: "idle", // or: 'loading', 'success', 'failed'
  deleteStatus: "idle", // or: 'loading', 'success', 'failed'
};

const Team = (state = INIT_STATE, action) => {
  switch (action.type) {
    /**
     * GET
     */
    case GET_TEAM:
      return {
        ...state,
        status: "loading",
        error: "",
      };

    case RECEIVED_TEAM:
      return {
        ...state,
        team: action.payload,
        status: "idle",
      };

    case GET_TEAM_SUCCESS:
      return {
        ...state,
        status: "success",
      };

    case GET_TEAM_FAILED:
      return {
        ...state,
        error: action.payload,
        status: "failed",
      };

    /**
     * INVITE
     */
    case INVITE_TEAM:
      return {
        ...state,
        inviteStatus: "loading",
        inviteError: "",
      };

    case INVITE_TEAM_SUCCESS:
      return {
        ...state,
        inviteStatus: "success",
      };

    case INVITE_TEAM_FAILED:
      return {
        ...state,
        inviteStatus: "failed",
        inviteError: action.payload,
      };

    case RESET_INVITE_STATUS:
      return {
        ...state,
        inviteStatus: "idle",
      };

    /**
     * DELETE
     */
    case DELETE_TEAM:
      return {
        ...state,
        deleteStatus: "loading",
        deleteError: "",
      };

    case DELETE_TEAM_SUCCESS:
      return {
        ...state,
        deleteStatus: "success",
      };

    case DELETE_TEAM_FAILED:
      return {
        ...state,
        deleteStatus: "failed",
        deleteError: action.payload,
      };

    case RESET_DELETE_STATUS:
      return {
        ...state,
        deleteStatus: "idle",
      };

    case RESET_TEAM_ERROR:
      return {
        ...state,
        error: "",
        inviteError: "",
        deleteError: "",
      };

    default:
      return { ...state };
  }
};

export default Team;
